module.exports = __webpack_public_path__ + "img/素质教育@2x.cb98e2e3.png";